"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SprintSearchResult = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var use_on_click_index_1 = require("@hiyllo/ux/use-on-click-index");
var common_1 = require("../common");
var keyboard_hint_1 = require("../keyboard-hint");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var sprint_1 = require("@hiyllo/omni-common/src/types/tasks/sprint");
var styled_1 = require("@hiyllo/ux/styled");
var react_native_1 = require("react-native");
var PillContent = (0, styled_1.styledRN)(react_native_1.View, function (_a) {
    var overdue = _a.overdue;
    return ({
        backgroundColor: overdue ? '#f44336' : '#5f5e62',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 20,
        gap: 5,
        cursor: 'pointer',
        height: 26
    });
});
exports.SprintSearchResult = react_1["default"].memo(function SprintSearchResult(props) {
    // const onClick = useNavigateTo(
    //   {
    //     feature: Features.tasks,
    //     params:
    //       props.result.sprint.status === SprintStatusEnum.active
    //         ? {
    //             view: "sprint",
    //             sprintUUID: props.result.sprint.uuid,
    //           }
    //         : {
    //             view: "sprint-planning",
    //             sprintUUID: props.result.sprint.uuid,
    //             teamUUID: props.result.sprint.teamUUID,
    //           },
    //   },
    //   props.onClose,
    // );
    var onClick = react_1["default"].useCallback(function () {
        props.onUpdateResults([
            __assign(__assign({}, props.result), { type: 'tasks/sprint.kanban' }),
            __assign(__assign({}, props.result), { type: 'tasks/sprint.planning' }),
        ]);
    }, [props]);
    (0, use_on_click_index_1.useOnClickIndex)(onClick, props.index);
    return ((0, jsx_runtime_1.jsxs)(common_1.SearchResultContainer, __assign({ onPress: onClick }, { children: [(0, jsx_runtime_1.jsx)(keyboard_hint_1.SearchResultKeyboardHint, { showTabHint: true, value: (props.index + 1).toString() }), (0, jsx_runtime_1.jsx)(common_1.SearchResultText, { children: props.result.sprint.name }), props.result.team != null && props.result.sprint.status === sprint_1.SprintStatusEnum.active ? ((0, jsx_runtime_1.jsxs)(PillContent, { children: ["Active Sprint in ", props.result.team.name] })) : null, props.result.team != null && props.result.sprint.status === sprint_1.SprintStatusEnum["new"] ? ((0, jsx_runtime_1.jsxs)(PillContent, { children: ["Upcoming Sprint in ", props.result.team.name] })) : null, (0, jsx_runtime_1.jsx)(common_1.SearchResultAppLabel, { icon: pro_light_svg_icons_1.faRunning, title: "Sprint" })] })));
});
